import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

export const Wrapper: React.FC<{ className?: string }> = ({ children, className }) => (
  <div className={cn(styles.Wrapper, className)}>{children}</div>
)
